import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { buttonColorSelectAtom } from "../atoms/buttonColorSelectAtom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAudio } from "@fortawesome/free-solid-svg-icons";
import ProgressBar from "./ProgressBar";
import { motion, AnimatePresence } from "framer-motion";

const Study = ({
  socket,
  roomName,
  id,
  lastQuesObj,
  setMainQuesNum,
  studyCount,
  isParticipate,
  config,
}: {
  socket: any;
  roomName: any;
  id: any;
  lastQuesObj: any;
  setMainQuesNum: any;
  studyCount: any;
  isParticipate: boolean;
  config: any;
}) => {
  const [quesNum, setQuesNum] = useState(0);
  const [ques, setQues] = useState("");
  const [choices, setChoices] = useState([]);
  const [curTime, setCurTime] = useState(0);
  const [maxTime, setMaxTime] = useState(0);
  const [audioSrc, setAudioSrc] = useState("");
  const [engOrKor, setengOrKor] = useState("eng");
  // const buttonColor = useRecoilValue(buttonColorSelectAtom);
  const navigate = useNavigate();
  const buttonColor = "slate";
  const audioRef = useRef<HTMLAudioElement>(null); // 오디오 참조 생성

  const isSubmit = useRef<boolean>(false);
  const [isCorrect, setIsCorrect] = useState<boolean | null>(null);

  useEffect(() => {
    if (lastQuesObj) {
      if (config.gameType === "1" || config.gameType === "2") {
        setMainQuesNum(lastQuesObj.quesNum);
        setQuesNum(lastQuesObj.quesNum);
        setQues(lastQuesObj.ques);
        setChoices(lastQuesObj.choices);
      } else if (config.gameType === "4") {
        const obj = lastQuesObj.ques.find((o: any) => o.userId === id);
        setMainQuesNum(obj.quesNum);
        setQuesNum(obj.quesNum);
        setQues(obj.ques);
        setChoices(obj.choices);
      }
    }
  }, [lastQuesObj]);

  const checkLanguage = (input: any) => {
    if (input % 2 == 0) {
      return "eng";
    } else {
      return "kor";
    }
  };

  useEffect(() => {
    socket.on("make_ques", (quesObj: any) => {
      const lang = checkLanguage(quesObj.quesNum);
      //맞은 상태,제출 상태 초기화

      setMainQuesNum(quesObj.quesNum);
      setQuesNum(quesObj.quesNum);
      setQues(quesObj.ques);
      setengOrKor(lang);
      setAudioSrc(
        `http://uvlqtxcfrh.us14.qoddiapp.com/audio_concat/${quesObj.ques}?lang=${lang}`
      );
      setChoices(quesObj.choices);
      isSubmit.current = false;
      setIsCorrect(null);
    });
    socket.on("change_timer", (timerObj: any) => {
      setCurTime(+timerObj.curTime);
      setMaxTime(+timerObj.maxTime);
    });
    socket.on("time_out", () => {
      checkCorrect("-1");
    });

    return () => {
      socket.off("make_ques");
      socket.off("change_timer");
      socket.off("time_out");
    };
  }, []);

  const checkCorrectCallBack = (result: any) => {
    setIsCorrect(result);

    try {
      if (result) {
        const audio = new Audio("audio/bonus-point.mp3");
        audio.play();
      } else {
        const audio = new Audio("audio/wrong-answer.mp3");
        audio.play();
      }
    } catch (e) {}
  };

  const checkCorrect = (ans: any) => {
    if (isSubmit.current) return;
    if (!socket.connected) return;
    isSubmit.current = true;
    if (config.gameType === "1" || config.gameType === "2")
      socket.emit("check_correct", roomName, id, ans, checkCorrectCallBack);
    else if (config.gameType === "4")
      socket.emit(
        "basic/know/check_correct",
        roomName,
        id,
        ans,
        checkCorrectCallBack
      );
  };

  const handlePlayAudio = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  return (
    <div>
      <div className="p-3">
        <ProgressBar curTime={curTime} maxTime={maxTime} />
      </div>
      <div className="flex flex-col justify-center p-3 dark:bg-gray-700 relative">
        {/* 오버레이 조건부 렌더링 */}
        <AnimatePresence>
          {isCorrect !== null && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.5 }}
              className={`fixed inset-0 flex items-center justify-center z-50 ${
                isCorrect ? "text-green-500" : "text-red-500"
              }`}
            >
              <div className="text-9xl font-bold">{isCorrect ? "O" : "X"}</div>
            </motion.div>
          )}
        </AnimatePresence>
        <div className="flex flex-col h-full shadow justify-center items-center rounded-lg pb-8 p-6 xl:p-8 mt-3 bg-gray-50 dark:bg-gray-900">
          <div>
            {isParticipate ? (
              <h4 className="font-bold text-2xl leading-tight">
                <div className="p-3 flex gap-3">
                  <span className="px-1 inline-flex text-lg leading-5 font-semibold border-2 border-orange-500 rounded-md pt-2 text-orange-500 hover:bg-orange-500 hover:text-white dark:text-orange-400 dark:border-orange-400 dark:hover:bg-orange-400 dark:hover:text-black">
                    {quesNum + 1}/{studyCount}
                  </span>
                  <span className="select-none text-2xl text-slate-700 dark:text-slate-300">
                    {ques}
                  </span>
                  <audio autoPlay src={audioSrc} ref={audioRef}>
                    오디오다
                  </audio>
                  <button
                    onClick={handlePlayAudio}
                    className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-500 hover:bg-blue-600 text-white focus:outline-none"
                  >
                    <FontAwesomeIcon icon={faFileAudio} className="text-xl" />
                  </button>
                  {isCorrect === null
                    ? ""
                    : isCorrect === true
                    ? "정답"
                    : "오답"}
                </div>
              </h4>
            ) : (
              <div className="p-3 flex gap-3">
                <span className="px-1 pb-2 inline-flex text-lg leading-5 font-semibold border-2 border-teal-500 rounded-md pt-2 text-teal-500 hover:bg-teal-500 hover:text-white dark:text-teal-400 dark:border-teal-400 dark:hover:bg-teal-400 dark:hover:text-black">
                  {quesNum + 1}/{studyCount}
                </span>
                <span className="select-none text-2xl text-slate-700 dark:text-slate-300">
                  {ques}
                </span>
              </div>
            )}
          </div>
          <div>
            <div className="mt-1 inline-flex font-bold items-center border-2 border-transparent outline-none focus:ring-1 focus:ring-offset-2 focus:ring-link active:bg-link active:text-gray-700 active:ring-0 active:ring-offset-0 leading-normal bg-link text-gray-700 hover:bg-opacity-80 text-base rounded-lg py-1.5 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700">
              <div className="p-3">
                {isParticipate && choices ? (
                  <div className="grid grid-cols-2 gap-3">
                    {choices.map((ans, idx) => (
                      <div className="rounded-md shadow mb-3" key={idx}>
                        <button
                          onClick={() => checkCorrect(ans)}
                          className={`${
                            isSubmit.current ? (isCorrect ? "" : "") : ""
                          } leading-normal select-none h-20 w-32 sm:h-auto sm:w-full flex items-center justify-center px-3 py-1 text-base font-medium rounded-md text-white dark:text-slate-800 bg-slate-500 dark:bg-slate-200 md:hover:bg-slate-300 md:hover:text-slate-700 md:dark:hover:text-white md:dark:hover:bg-slate-500 md:hover:ring ring-offset-2 ring-slate-400 dark:ring-slate-600 focus:outline-none transition duration-300 ease-in-out md:py-4 md:text-lg md:px-10 transform active:translate-y-3`}
                        >
                          {ans}
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  "반장은 참여중이 아닙니다."
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Study;
